import React, { useState, useEffect, useMemo } from 'react';
import ModalCloseIcon from '@/components/general/ModalCloseIcon/ModalCloseIcon';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';

const Step = ({ number, label, active, onClick, disabled }) => {
  return (
    <FlexContainer
      className={'flex-column align-items-center'}
      style={{
        minWidth: 80,
      }}
      onClick={() => {
        if (!disabled && onClick) onClick();
      }}
    >
      <FlexContainer
        className={
          'width-26px height-26px align-items-center justify-center text-12 index-2'
        }
        style={{
          borderRadius: '50%',
          background: active ? '#6f8ec0' : '#ffffff',
          border: active ? '3px solid #6f8ec0' : '3px solid #6f8ec0',
          boxShadow: active ? '0 2px 6px rgba(87,180,62,0.25)' : 'none',
          color: active ? '#fff' : '#000001',
          fontWeight: 800,
        }}
      >
        {number}
      </FlexContainer>

      <Label
        className={'text-10 margt4 text-center width-180px'}
        style={{
          color: '#53595f',
          fontWeight: '700',
        }}
      >
        {label}
      </Label>
    </FlexContainer>
  );
};

const AgendaTipoCitaModal = ({
  open,
  onClose,
  goStep2,
  goStep3,
  goStep4,
  listaEspecialidades,
  changueEspFilter,
  selectedSpeciality,
  currentStep,
  setCurrentStep,
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  const especialidadesFiltradas = listaEspecialidades.filter(esp =>
    esp.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const selectEspecialidad = esp => {
    changueEspFilter(esp, false);
    goStep2();
    setCurrentStep(2);
  };

  if (!open) return null;

  return (
    <FlexContainer
      className="pos-fixed justify-center align-center"
      style={{
        inset: 0,
        background: 'rgba(0,0,0,0.45)',
        zIndex: 9999,
        padding: 20,
      }}
    >
      <FlexContainer
        className="pos-rel flex-column width-940px m-format90 height-620px padtb26 padlr32"
        style={{
          borderRadius: '6px 6px 6px 6px',
          boxShadow: '0px 8px 22px rgba(0,0,0,0.15)',
          background: '#ffffff',
        }}
      >
        <FlexContainer
          onClick={onClose}
          className="pos-abs pointer top16 right16 width-38px height-38px text-22 align-items-center justify-center fontWhite"
          style={{
            background: '#023B7A',
            borderRadius: '50%',
            fontWeight: 'bold',
            boxShadow: '0px 3px 6px rgba(2,59,122,0.3)',
          }}
        >
          <ModalCloseIcon />
        </FlexContainer>

        <div
          className="width-860px height-550px m-format100 m-margt30 bgWhite borderrad20 padtb16 padlr10 pos-rel margb20 left20 m-left0"
          style={{
            zIndex: 5,
          }}
        >
          <FlexContainer className="padlr60 width100 margb8 m-hide">
            <FlexContainer className="align-items-center pos-rel">
              <FlexContainer
                className="pos-abs left80 right80 top12 height-2px borderrad4 index-1"
                style={{
                  background: '#6f8ec0',
                }}
              />

              <FlexContainer className="justify-between width100 index-2">
                <Step
                  number={1}
                  label={'Especialidad'}
                  active={currentStep === 1}
                  onClick={() => setCurrentStep(1)}
                  disabled={false}
                />
                <Step
                  number={2}
                  label={'Médico'}
                  active={currentStep === 2}
                  onClick={() => currentStep >= 2 && setCurrentStep(2)}
                  disabled={currentStep < 2}
                />
                <Step
                  number={3}
                  label={'Fecha y Hora Disponibles'}
                  active={currentStep === 3}
                  onClick={() => currentStep >= 3 && setCurrentStep(3)}
                  disabled={currentStep < 3}
                />
                <Step
                  number={4}
                  label={'Confirmar Reserva de Cita'}
                  active={currentStep === 4}
                  onClick={() => currentStep >= 4 && setCurrentStep(4)}
                  disabled={currentStep < 4}
                />
              </FlexContainer>
            </FlexContainer>
          </FlexContainer>
          <FlexContainer className={'align-items-center gap-10 padtb0 margb8'}>
            <div className={'text-18'} style={{ fontWeight: 600 }}>
              <span style={{ color: '#023B7A' }}>
                <strong>Agenda una cita |</strong>
              </span>
              <span style={{ color: '#6f8ec0', fontWeight: 500 }}>
                {' '}
                Elige tu especialidad
              </span>
            </div>
          </FlexContainer>
          <FlexContainer className="flex-row gap-12 margt4">
            <FlexContainer className="pos-rel width-280px m-format100">
              <select
                className="width100 height-40px padtb6 padr40px padl12 text-14 borderrad4 bgWhite"
                style={{
                  border: '1px solid #C9C9C9',
                  color: '#144796',
                  fontWeight: 600,
                  appearance: 'none',
                }}
              >
                <option>Miraflores</option>
              </select>
              <span
                className="pos-abs right10 text-24 pointerEventsNone"
                style={{
                  top: '50%',
                  transform: 'translateY(-50%) rotate(270deg)',
                  fontWeight: 900,
                  color: '#144796',
                }}
              >
                ‹
              </span>
            </FlexContainer>

            <FlexContainer className="flex-1 align-items-center pos-rel">
              <i
                className="fas fa-search pos-abs left10 text-16"
                style={{
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#144696',
                }}
              ></i>
              <input
                type="text"
                placeholder="Busca tu especialidad"
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
                className="width100 height-22px padtb8 padr12 padl36 borderrad4 text-14 outlineNone bgWhite"
                style={{
                  border: '1px solid #C9C9C9',
                  fontWeight: 500,
                }}
              />
            </FlexContainer>
          </FlexContainer>

          <FlexContainer className="my-custom-scroll margt16 width100 height-360px overflowY padr0 pos-rel padb16">
            {searchTerm === '' && (
              <FlexContainer
                className={
                  window.innerWidth > 1024
                    ? 'grid gap-12 padr10 autoCenter'
                    : 'm-flex-column gap-12 padr10 autoCenter'
                }
                style={{
                  gridTemplateColumns:
                    window.innerWidth > 1024 ? 'repeat(4, 1fr)' : 'none',
                }}
              >
                {listaEspecialidades.map((s, i) => (
                  <FlexContainer
                    key={i}
                    className="height-100px pointer flex-row align-center gap-10 borderrad16 bgWhite padtb10 padlr12 align-items-center"
                    onClick={() => selectEspecialidad(s)}
                    style={{
                      minHeight: 72,
                      border: '1px solid #EAEAEA',
                      boxShadow: '0px 2px 6px rgba(0,0,0,0.06)',
                      transition: 'transform 0.18s ease, box-shadow 0.18s ease',
                    }}
                  >
                    <FlexContainer
                      className="flex-column justify-center flex-1 align-items-center"
                      style={{
                        minWidth: 0,
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                      }}
                    >
                      <Label
                        className="text-12 fontSemiBold lineHeight-1"
                        style={{ color: '#023B7A', textAlign: 'center' }}
                      >
                        {s}
                      </Label>
                      <Label
                        className="text-10 font-medium margt4"
                        style={{ color: '#6b6b6b' }}
                      ></Label>
                    </FlexContainer>
                  </FlexContainer>
                ))}
              </FlexContainer>
            )}
            {searchTerm !== '' && (
              <FlexContainer
                className="grid gap-12 padr10"
                style={{
                  gridTemplateColumns: 'repeat(4, 1fr)',
                }}
              >
                {especialidadesFiltradas.map((s, i) => (
                  <FlexContainer
                    key={i}
                    className="height-100px pointer flex-row align-center gap-10 borderrad16 bgWhite padtb10 padlr12 align-items-center"
                    onClick={() => selectEspecialidad(s)}
                    style={{
                      minHeight: 72,
                      border: '1px solid #EAEAEA',
                      boxShadow: '0px 2px 6px rgba(0,0,0,0.06)',
                      transition: 'transform 0.18s ease, box-shadow 0.18s ease',
                    }}
                  >
                    {/* <FlexContainer className="width-40px height-40px align-items-center justify-center noShrink overflow-hidden">
                      <img
                        src={`/images/Cardiología.png`}
                        alt={s}
                        className="width100 height100 objectContain"
                      />
                    </FlexContainer> */}

                    <FlexContainer
                      className="flex-column justify-center flex-1 align-items-center"
                      style={{
                        minWidth: 0,
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                      }}
                    >
                      <Label
                        className="text-12 fontSemiBold lineHeight-1"
                        style={{ color: '#023B7A', textAlign: 'center' }}
                      >
                        {s}
                      </Label>
                      <Label
                        className="text-10 font-medium margt4"
                        style={{ color: '#6b6b6b' }}
                      ></Label>
                    </FlexContainer>
                  </FlexContainer>
                ))}
              </FlexContainer>
            )}
          </FlexContainer>
        </div>
      </FlexContainer>
    </FlexContainer>
  );
};

export default AgendaTipoCitaModal;
